import React, { useState, useCallback, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { CrossIcon } from "../verticalDropdown/svgData";
// import { wpPath } from "../../config/key";
// import { useNavigate } from "react-router-dom";
import Loading from "../Animation/Loading";
import { withoutAuth } from "../../config/axios";

const PrintPopup = ({ showPopup, setShowPopup, payload }) => {
  const [loadingState, setLoadingState] = useState({
    proceed: false,
    save: false,
  });
  const [token, setToken] = useState("");
  const [error, setError] = useState("");

  // Request fresh token from parent
  const requestToken = useCallback(() => {
    console.log("[Token] Requesting fresh token from parent...");
    window.parent.postMessage("iframeIsReadyToReceiveUserData", "*");
  }, []);

  // Handle incoming messages
  useEffect(() => {
    console.log("[Event] Setting up message listener...");

    const handleMessage = (event) => {
      // console.group("[Event] Message Received");
      // console.log("Origin:", event.origin);
      // console.log("Expected Origin:", process.env.REACT_APP_WP_BASE_URL);
      console.log("Event Data:", event.data);

      if (event.origin === process.env.REACT_APP_WP_BASE_URL || event.origin === window.location.origin) {
        if (event.data && typeof event.data === 'object' && event.data.is_wp) {
          const { token } = event.data;
          if (token) {
            console.log("[Token] Received new token");
            setToken(token);
            setError(""); // Clear any previous errors
          } else {
            console.warn("[Token] Message received but no token found");
          }
        }
      } else {
        console.warn("[Security] Message from unexpected origin:", event.origin);
      }
      console.groupEnd();
    };

    window.addEventListener("message", handleMessage);
    return () => {
      console.log("[Cleanup] Removing message listener");
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  // Handle visibility changes and token refresh
  useEffect(() => {
    if (!showPopup) {
      console.log("[Popup] Not visible - skipping setup");
      return;
    }

    console.log("[Popup] Initializing token management...");

    // Request token immediately when popup shows
    requestToken();

    const handleVisibilityChange = () => {
      console.group("[Event] Visibility Change");
      console.log("Current state:", document.visibilityState);

      if (document.visibilityState === 'visible') {
        console.log("[Token] Page became visible - requesting fresh token");
        requestToken();
      } else {
        console.log("[Token] Page hidden - no action needed");
      }
      console.groupEnd();
    };

    // Set up interval for token refresh (every 10 minutes)
    console.log("[Token] Setting up 10-minute refresh interval");
    const interval = setInterval(() => {
      console.log("[Token] Interval refresh triggered");
      requestToken();
    }, 10 * 60 * 1000);

    console.log("[Event] Adding visibilitychange listener");
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      console.log("[Cleanup] Clearing interval and removing listeners");
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [showPopup, requestToken]);

  const handleAction = useCallback(
    async (proceed = false) => {
      console.group("[Action] Handling user action");
      console.log("Action type:", proceed ? "Proceed to Checkout" : "Save and make another");
      console.log("Current token:", token ? "Available" : "Missing");

      setLoadingState((prev) => ({ ...prev, [proceed ? "proceed" : "save"]: true }));
      setError("");

      // const token = localStorage.getItem("fcrf@token");
      // if (!token) {
      //   window.location.href = process.env.REACT_APP_WP_APP_LOGIN;
      //   return;
      // }

      try {

        const res = await withoutAuth().post("report/proceed-to-checkout", proceed ? { ...payload, path: "checkout" } : { ...payload, path: "rarity-report" });
        if (res?.status !== 200) {
          throw new Error(res?.msg || "Your session is expired. Please reload the page.");
        }
        const { checkout_url, message } = res?.data;

        if (checkout_url) {
          window.parent.location.href = checkout_url;
        } else {
          throw new Error(message || "There is some error. Please try again.");

        }
        // if (!res?.checkout_url) {
        //   throw new Error("Your session is expired. Please reload the page.");
        // }
        // window.parent.location.href = checkout_url;
        // if (proceed) {
        //   window.parent.location.href = res.checkout_url;
        //   // window.location.reload();
        // } else {
        //   const newWindow = window.open(res.checkout_url, "_blank");
        //   if (newWindow) {
        //     setTimeout(() => {
        //       newWindow.close();
        //       navigate("/");
        //       setLoadingState((prev) => ({ ...prev, save: false }));
        //       setShowPopup(false);
        //     }, 5000);
        //   }
        //    else {
        //     throw new Error("Popup blocked. Please allow popups for this site.");
        //   }
        // }
      } catch (err) {
        setError(err.message || "Your session is expired. Please reload the page.");
        setLoadingState((prev) => ({
          ...prev,
          [proceed ? "proceed" : "save"]: false,
        }));
      }
    },
    [payload, token]
  );


  // const declarationText = `I am the rightful owner of the ${payload?.weight} carat diamond${
  //   payload?.gia ? `, with GIA report number ${payload?.gia}` : ""
  // }. I acknowledge that only one original printed Rarity Report will be issued and recorded. Future requests will be verified against this declaration.`;

  const declarationText = `I have the full rights to issue a rarity report for this ${payload?.weight} ct. diamond.`;

  return (
    <Modal
      className="diary-notice-modal rarity-order-popup-modal"
      show={showPopup}
      centered
      onHide={() => setShowPopup(false)}
    >
      <Modal.Header>
        <div className="cross-icon" onClick={() => setShowPopup(false)}>
          <CrossIcon />
        </div>
      </Modal.Header>
      <Modal.Body className="py-0 pb-5">
        <div className="">
          <p className="fw-bold text-center mb-2">Declaration</p>
          <p className="text-center">{declarationText}</p>

          <div className="d-flex flex-column gap-3 mt-3 order-section">
            {loadingState.save ? <Loading text="Saving" type={"modal"} loadingBtn="loader-btn" /> : <Button
              className="processBtn rarity-make-another-btn"
              onClick={() => handleAction(false)}

              disabled={loadingState.save || loadingState.proceed}
            >
              Order another one
            </Button>}
            {
              loadingState.proceed ? <Loading text="Processing" type={"modal"} loadingBtn="loader-btn" /> :
                <Button
                  className="outline-btn rarity-make-another-btn"
                  // style={{
                  //   maxWidth: "280px",
                  //   padding: "10px 23px",
                  //   margin: "0 auto",
                  //   minWidth: "220px",
                  // }}
                  onClick={() => handleAction(true)}
                  disabled={loadingState.proceed || loadingState.save}
                >
                  Proceed to checkout
                </Button>
            }
          </div>

          {error && (
            <p className="text-danger text-center mt-2">{error}</p>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default React.memo(PrintPopup);